import React from "react";
import PropTypes from "prop-types";
import MUIRadioGroup from "@material-ui/core/RadioGroup";
import FormLabel from "@material-ui/core/FormLabel";

const RadioGroup = ({ name, selectedValue, onChange, children, label, ...props }) => {
  return (
    <>
      {label && <FormLabel>{label}</FormLabel>}
      <MUIRadioGroup name={name} value={selectedValue} onChange={onChange} {...props}>
        {children}
      </MUIRadioGroup>
    </>
  );
};

RadioGroup.propTypes = {
  /*
   * Label del radiogroup
   */
  label: PropTypes.string.isRequired,
  /*
   * Nombre del radiogroup
   */
  name: PropTypes.string.isRequired,
  /*
   * Valor seleccionado
   */
  selectedValue: PropTypes.string,
  /*
   * Callback que se llama cuando cambia el valor seleccionado
   */
  onChange: PropTypes.func,
};

export default RadioGroup;
